<sl-label size="large" i18n>Planning</sl-label>


<sl-well *ngIf="settings">
    <sl-list lines="full">
        <sl-list-item>
            <sl-label size="small" i18n>Automatic routeplanning</sl-label>
            <sl-switch slot="suffix" [(ngModel)]="autoPlanEnabled" (ngModelChange)="submit()"></sl-switch>
        </sl-list-item>
        <sl-list-item>
            <sl-label size="small" i18n>Transfer work to other employee when absent</sl-label>
            <sl-switch slot="suffix" [disabled]="!autoPlanEnabled" [(ngModel)]="settings.adjustPlanForNonWorkDays"
                (ngModelChange)="submit()"></sl-switch>
        </sl-list-item>
        <sl-list-item>
            <sl-label size="small" i18n>Recalculate route planning on the current date</sl-label>
            <sl-label size="small" multiline color="medium" 
                i18n>Updates times for tasks on the current date when they are completed and recalculates the rest of the route.</sl-label>
            <sl-switch slot="suffix" [disabled]="!autoPlanEnabled" [(ngModel)]="dynamicallyPlanCurrentDay"
                (ngModelChange)="submit()">
            </sl-switch>
        </sl-list-item>
        <sl-list-item>
            <sl-label class="col-span-3" size="small" i18n>Smallest service window</sl-label>
            <sl-select hoist size="small" slot="suffix" [disabled]="!autoPlanEnabled"
                [(ngModel)]="settings.minimumTimeWindowDuration" (ngModelChange)="submit()">
                <sl-menu-item value="PT2H" i18n>2 hours</sl-menu-item>
                <sl-menu-item value="PT3H" i18n>3 hours</sl-menu-item>
                <sl-menu-item value="PT4H" i18n>4 hours</sl-menu-item>
                <sl-menu-item value="PT5H" i18n>5 hours</sl-menu-item>
                <sl-menu-item value="PT6H" i18n>6 hours</sl-menu-item>
                <sl-menu-item value="PT7H" i18n>7 hours</sl-menu-item>
            </sl-select>
        </sl-list-item>
    </sl-list>
</sl-well>